import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  CustomerListFilterRootParamList,
  CustomerRootParamList,
} from "../../../../types";
import { useTranslation } from "../../../../utilities/i18n";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import { CustomerFilterValues } from "../../types";
import {
  Button,
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";

import { CustomerListFilterScreen } from "../CustomerListFilterScreen";

export interface CustomerListFilterRootScreenProps
  extends StackScreenProps<
    CustomerRootParamList,
    "CustomerListFilterRootScreen"
  > {}

export const CustomerListFilterRootScreen =
  ({}: CustomerListFilterRootScreenProps) => {
    const { t } = useTranslation("customer");

    const { filterState, clearAll } =
      useListFilterContext<CustomerFilterValues>();
    const { activeFiltersCount } = filterState;

    const RootNavigator =
      createStackHeaderNavigator<CustomerListFilterRootParamList>();

    return (
      <RootNavigator.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <RootNavigator.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Close" />,
            title: "",
            headerRight() {
              return (
                <Button
                  label={t("common:clear_filters")}
                  isAction
                  disabled={activeFiltersCount == 0}
                  onPress={clearAll}
                  size="compact"
                ></Button>
              );
            },
          }}
        >
          <RootNavigator.Screen
            name="CustomerListFilterScreen"
            component={CustomerListFilterScreen}
          />
        </RootNavigator.Group>
      </RootNavigator.Navigator>
    );
  };
